/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
  ExtendedBox,
  Image,
  Link,
  StyledButton,
} from '../../coreui';

import downloadIcon from '../../assets/icon_download.svg';
import Webinar from './webinar';

// eslint-disable-next-line
class QuickLinks extends React.Component {
  // eslint-disable-next-line
  showZendesk() {
    if (typeof zE !== 'undefined') {
      // eslint-disable-next-line
      zE.activate();
    }
  }

  render() {
    const {
      showKeyLine,
      webinar,
      documents,
      ...passedProps
    } = this.props;

    return (
      <ExtendedFlex
        {...passedProps}
        flexDirection={['column', 'column', 'row']}
        justifyContent="center"
        mx={[20, 20, 20, 20, 0]}
        borderTop={showKeyLine ? '1px solid' : null}
        borderColor="gray.7"
        my={[10, 10, 0]}
        pt={[30, 30, 0]}
      >
        <Webinar {...webinar} />
        {documents &&
          documents[0] &&
          documents.map((doc) => {
            return (
              <ExtendedFlex
                flexBasis="100%"
                bg="gray.1"
                p={15}
                textAlign="center"
                my={[5, 5, 30]}
                mx={10}
                key={doc.url}
              >
                <ExtendedBox textAlign="center">
                  <Image
                    src={downloadIcon}
                    mr={10}
                    height="20px"
                    position="relative"
                    top="4px"
                    display="inline-block"
                  />
                  <Link
                    href={doc.url}
                    target="_blank"
                    type="L4"
                    lineHeight="26px"
                  >
                    {doc.title}
                  </Link>
                </ExtendedBox>
              </ExtendedFlex>
            );
          })}
        <ExtendedFlex
          flexBasis="100%"
          bg="gray.1"
          p={15}
          textAlign="center"
          my={[5, 5, 30]}
          mx={10}
        >
          <ExtendedBox textAlign="center">
            <Image
              src={downloadIcon}
              mr={10}
              height="20px"
              position="relative"
              top="4px"
              display="inline-block"
            />
            <StyledButton
              type="L4"
              lineHeight="26px"
              onClick={this.showZendesk}
            >
              Contact Investor Relations
            </StyledButton>
          </ExtendedBox>
        </ExtendedFlex>
      </ExtendedFlex>
    );
  }
}

QuickLinks.propTypes = {
  documents: PropTypes.array,
  webinar: PropTypes.string,
  showKeyLine: PropTypes.bool,
};

export default QuickLinks;
